import {dsvFormat} from 'd3';
import {getUrlExtension} from 'utils/urls';
import 'whatwg-fetch';

export default function fetchData(
  dataUrl: string,
  onDataReceived: (data: unknown) => void,
  onError: (error: Error) => void,
  csvDelimiter = ';',
) {
  const ext = getUrlExtension(dataUrl);

  window
    .fetch(dataUrl)
    .then(res => {
      if (res.status !== 200) {
        console.error(res);
        throw new Error(`Ошибка HTTP ${res.status} во время загрузки ${dataUrl}`);
      } else if (ext === 'json') {
        return res.json();
      } else if (ext === 'arraybuffer') {
        return res.arrayBuffer();
      } else if (ext === 'bin') {
        return res.blob();
      }
      return res.text();
    })
    .then((data: unknown) => {
      if (ext === 'csv') {
        onDataReceived(dsvFormat(csvDelimiter).parse(data as string));
      } else if (ext === 'tsv') {
        onDataReceived(dsvFormat('\t').parse(data as string));
      } else {
        onDataReceived(data);
      }
    })
    .catch(err => {
      onError(err);
    });
}
